module.exports = __webpack_public_path__ + "img/credential-logo-niice.48c3f3ec6b5607631c99f89f734facfe.svg";